import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

export const initI18next = i18next
  .use(initReactI18next)
  .init({
    ns: ['default'],
    defaultNS: 'default',
    supportedLngs: ['en', 'ru'],
    react: { useSuspense: true },
  })
